import React, { useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";
import { IconButton, IconButtonProps } from "@mui/material";
import { ArrowSplideLeft, ArrowSplideRight } from "../../../icons";

type usePrevNextHomeButtonsProps = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevNextHomeButtons = (
  emblaApi: EmblaCarouselType | undefined
): usePrevNextHomeButtonsProps => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};
type PropType = IconButtonProps;

export const PrevHomeButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <IconButton
      className="embla__button__home embla__button--prev"
      type="button"
      {...restProps}
    >
      <ArrowSplideLeft
        sx={{
          width: { xs: "15px !important", md: "24px !important" },
          height: { xs: "15px !important", md: "24px !important" },
        }}
        htmlColor="#c4c4c4ff"
      />
    </IconButton>
  );
};

export const NextHomeButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <IconButton
      className="embla__button__home embla__button--next"
      type="button"
      {...restProps}
    >
      <ArrowSplideRight
        sx={{
          width: { xs: "15px !important", md: "24px !important" },
          height: { xs: "15px !important", md: "24px !important" },
        }}
        htmlColor="#c4c4c4ff"
      />
    </IconButton>
  );
};
